import React from 'react';
import { LIBRARY_CRITERIA } from './salesData';
import { PHOTOS } from '../data/photos';
export function LibrarySection() {
  return <section id="biblioteca" className="relative overflow-hidden bg-charcoal py-12 text-white sm:py-16" data-id="element-174" data-mp="23cadenarkkqu">
      {/* Fotografía de la colección completa, atenuada para que el texto
          mantenga contraste pleno sobre el violeta profundo. */}
      <div className="pointer-events-none absolute inset-0" aria-hidden data-id="element-175" data-mp="1pl5nicx776tp">
        <img src={PHOTOS.collection} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover opacity-25" data-id="element-176" data-mp="1pjb2yzpu9gq5" />
        <div className="absolute inset-0 bg-charcoal/85" data-id="element-177" data-mp="1yf0gkml1p6sz" />
      </div>

      <div className="relative mx-auto max-w-md px-5 text-center sm:max-w-2xl" data-id="element-178" data-mp="1tlxvz3y8x7ox">
        <h2 className="font-display text-[1.5rem] font-extrabold leading-[1.12] tracking-tight sm:text-[2.1rem]" data-id="element-179" data-mp="15wwgwxuwqyao">
          No necesitás fabricar 200 jabones.
          <span className="mt-1.5 block font-accent text-[1.15rem] font-medium tracking-normal text-champagne sm:text-[1.5rem]" data-id="element-180" data-mp="11tqddxz6jl7w">
            Necesitás 200 posibilidades para elegir.
          </span>
        </h2>

        <p className="mx-auto mt-4 max-w-[42ch] font-sans text-[0.88rem] leading-relaxed text-white/70" data-id="element-181" data-mp="176o7woqx6amd">
          Las 200 fórmulas funcionan como una biblioteca de consulta: entrás, elegís qué querés
          fabricar y lo hacés.
        </p>

        <ul className="mt-6 flex flex-wrap justify-center gap-1.5" data-id="element-182" data-mp="ej24phllt801">
          {LIBRARY_CRITERIA.map(c => <li key={c} className="rounded-full bg-white/[0.08] px-3 py-1.5 font-sans text-[0.76rem] font-medium text-white/85" data-id="element-183" data-mp="jhlslnjrctv1">
              {c}
            </li>)}
        </ul>
      </div>
    </section>;
}